import React, { useState, useEffect, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";

import GenericTemplate from "../../../templates/GenericTemplate";
import {
  apollo_useStyles,
  options_zeus_campaign_type,
} from "../../../atom/Apollo_styles";
import {
  get_zeus_campaign_path,
  get_zeus_ad_group_performance_path,
  post_zeus_review_csv_path,
} from "../../../atom/Apollo_links";
import {
  ApolloBreadcrumbs2,
  BreadcrumbsData,
} from "../../../atom/Apollo_Breadcrumbs2";
import { ApolloContext } from "../../../atom/Apollo_Context";
import {
  ApolloMessage,
  CustomizedSnackbars,
} from "../../../atom/Apollo_Mesasge";
import { ApolloAxios } from "../../../atom/Apollo_ApiRequest3";
import { ReviewCsvRequestZeus } from "./ReviewCsvModel";
import { UNDER_SCORE, ZERO } from "../../../common/Apollo_CommonConst_Beta";

/*
  画面名：審査結果ダウンロードリクエスト作成
*/

const initReviewCsvRequest: ReviewCsvRequestZeus = {
  adAccountId: ZERO,
  deliveryTypes: [],
  adCampaignIds: [],
  adGroupIds: [],
  archiveFlag: false,
};

type CampaignOption = {
  value: number;
  label: string;
  deliveryType: number;
};

type AdGroupOption = {
  value: number;
  label: string;
  adCampaignId: number;
};

const ReviewCsvRequest: React.FC = () => {
  const { state } = useContext(ApolloContext);
  const { data, setmsg } = useContext(ApolloMessage);
  const { accountgroupid, accountid, platformaccountid } = useParams<{
    accountgroupid: string;
    accountid: string;
    platformaccountid: string;
  }>();
  const classes = apollo_useStyles();
  const history = useHistory();
  const handleGoback = () => history.goBack();

  const [platformAccountName, setPlatformAccountName] = useState<string>("");
  const [campaignOptions, setCampaignOptions] = useState<CampaignOption[]>([]);
  const [adgroupOptions, setAdgroupOptions] = useState<AdGroupOption[]>([]);

  const [selectedCampaignKindValues, setSelectedCampaignKindValues] = useState<
    number[]
  >([]);
  const [selectedCampaignValues, setSelectedCampaignValues] = useState<
    CampaignOption[]
  >([]);
  const [selectedAdgroupValues, setSelectedAdgroupValues] = useState<
    AdGroupOption[]
  >([]);

  const [reviewCsvRequest, setReviewCsvRequest] =
    useState<ReviewCsvRequestZeus>(initReviewCsvRequest);

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 27,
    breadId: 2,
    queries: [],
    menu: {
      id: 1,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  };

  // 初期表示でキャンペーン取得
  useEffect(() => {
    setPlatformAccountName(state.current.accountName);

    const campaignUrl = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_campaign_path}?account_id=${platformaccountid}&per_page=9999&page=1&sort=created&direction=desc`;

    ApolloAxios.get(campaignUrl)
      .then((response) => {
        const campaigns = response.data.map((c: any) => ({
          value: c.id,
          label: `${c.id}${UNDER_SCORE}${c.name}`,
          deliveryType: c.deliveryType,
        }));
        setCampaignOptions(campaigns);
      })
      .catch((err) => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "キャンペーン情報を取得できませんでした",
          },
        });
      });

    // 広告グループ取得
    const startDate = "2025-11-01";
    const endDate = "2025-11-19";
    const adgroupUrl = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ad_group_performance_path}?account_id=${platformaccountid}&startDateTime=${startDate}&endDateTime=${endDate}&per_page=9999&page=1&sort=created&direction=desc`;

    ApolloAxios.get(adgroupUrl, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${state.accesstoken}`,
      },
    })
      .then((response) => {
        const list = response.data.result.list ?? [];
        const adgroups: AdGroupOption[] = list.map((ad: any) => ({
          value: ad.id,
          label: `${ad.id}${UNDER_SCORE}${ad.name}`,
          adCampaignId: ad.adCampaignId,
        }));
        setAdgroupOptions(adgroups);
      })
      .catch((err) => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "広告グループ情報の取得に失敗しました",
          },
        });
      });
  }, [platformaccountid, state.current.accountName]);

  // 選択したキャンペーン種別に紐づくキャンペーンだけを表示
  const filteredCampaigns = campaignOptions
    .filter((c) => selectedCampaignKindValues.includes(c.deliveryType))
    .sort((a, b) => a.label.localeCompare(b.label));

  // 選択したキャンペーンに紐づく広告グループだけを表示
  const filteredAdgroups = adgroupOptions
    .filter((ad) =>
      selectedCampaignValues.some((c) => ad.adCampaignId === c.value)
    )
    .sort((a, b) => a.label.localeCompare(b.label));

  const onSubmit = () => {
    const req: ReviewCsvRequestZeus = {
      adAccountId: Number(platformaccountid),
      deliveryTypes: selectedCampaignKindValues,
      adCampaignIds: selectedCampaignValues.map((c) => c.value),
      adGroupIds: selectedAdgroupValues.map((a) => a.value),
      archiveFlag: reviewCsvRequest.archiveFlag,
    };

    const url = `${process.env.REACT_APP_API_ENDPOINT}${post_zeus_review_csv_path}`;

    ApolloAxios.post(url, req, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${state.accesstoken}`,
      },
    })
      .then((response) => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: "審査結果CSVの作成を受け付けました",
          },
        });
        handleGoback();
      })
      .catch((err) => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "審査結果CSVの作成に失敗しました",
          },
        });
      });
  };

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars />
      <ApolloBreadcrumbs2 data={breadcrumbsData} />
      <Grid container spacing={3}>
        <Grid item xs={12} lg={12}>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1">
                    広告アカウント(固定)
                  </Typography>
                  <Select
                    value={{
                      label: platformAccountName,
                      value: platformAccountName,
                    }}
                    isDisabled
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle1">キャンペーン種別</Typography>
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    options={options_zeus_campaign_type.map((o) => ({
                      value: o.value,
                      label: o.label,
                    }))}
                    value={options_zeus_campaign_type.filter((o) =>
                      selectedCampaignKindValues.includes(o.value)
                    )}
                    onChange={(vals: any) => {
                      const setVals = vals ? vals.map((v: any) => v.value) : [];
                      setSelectedCampaignKindValues(setVals);

                      // キャンペーンのフィルタリング
                      const filterCampaignValues =
                        selectedCampaignValues.filter((c) =>
                          setVals.includes(c.deliveryType)
                        );
                      setSelectedCampaignValues(filterCampaignValues);

                      // 広告グループのフィルタリング
                      const filterAdgroups = selectedAdgroupValues.filter(
                        (ad) =>
                          filterCampaignValues.some(
                            (c) => c.value === ad.adCampaignId
                          )
                      );
                      setSelectedAdgroupValues(filterAdgroups);
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle1">キャンペーン</Typography>
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    options={filteredCampaigns}
                    menuPlacement="auto"
                    maxMenuHeight={200}
                    menuPortalTarget={document.body}
                    value={selectedCampaignValues}
                    onChange={(vals: any) => {
                      const selected = vals || [];
                      setSelectedCampaignValues(selected);

                      // 広告グループのフィルタリング
                      const filterAdgroups = selectedAdgroupValues.filter(
                        (ad) =>
                          selected.some((c: any) => c.value === ad.adCampaignId)
                      );
                      setSelectedAdgroupValues(filterAdgroups);
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle1">広告グループ</Typography>
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    options={filteredAdgroups}
                    menuPlacement="auto"
                    maxMenuHeight={200}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 1300 }),
                    }}
                    value={selectedAdgroupValues}
                    onChange={(vals: any) =>
                      setSelectedAdgroupValues(vals || [])
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    アーカイブ
                  </Typography>
                  <RadioGroup
                    row
                    value={reviewCsvRequest.archiveFlag ? "true" : "false"}
                    onChange={(e) => {
                      const val = e.currentTarget.value === "true";
                      setReviewCsvRequest((prev) => ({
                        ...prev,
                        archiveFlag: val,
                      }));
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label="含む"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      label="含めない"
                    />
                  </RadioGroup>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <Button
                type="button"
                color="primary"
                onClick={onSubmit}
                variant="contained"
              >
                作成
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleGoback}
              >
                戻る
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </GenericTemplate>
  );
};

export default ReviewCsvRequest;
